/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import PropTypes from 'prop-types'
import { globalHistory } from '@reach/router'
import { prettyTracker } from '~helpers/getters'
import { setCookie } from '~helpers/cookies'
import keygen from '~helpers/keygen'
import { getTrackingAPIParams, trackerLinkActive } from '~helpers/tracker'

const PrettyLink = ({
  operator,
  directPrettyLink = null,
  pageTemplate,
  moduleName,
  tracker,
  titleSuffix,
  className,
  children,
  clickedElement = 'prettyLink',
  rel = 'nofollow sponsored',
  modulePosition,
  itemPosition
}) => {
  const prettyLink = prettyTracker(operator, tracker, false, pageTemplate)
  const referer =
    typeof document !== 'undefined' && document?.referrer
      ? document.referrer
      : ''
  
  const affObject = JSON.stringify(
    getTrackingAPIParams(
      pageTemplate,
      moduleName,
      tracker,
      clickedElement,
      globalHistory.location.href,
      referer,
      modulePosition,
      itemPosition
    )
  )
  

  const onCTAClick = () => {
    // eslint-disable-next-line no-unused-expressions
    process.env.IS_TRACKING_SSR &&
      setCookie(
        'affObject',
        affObject,
        1,
        '/'
      )

    if (
      process.env.ENABLE_PIXEL === 'true' &&
      typeof window.fbq !== 'undefined'
    ) {
      // Call fbq track event
      window.fbq('track', 'InitiateCheckout', { keyID: keygen() })
    }
  }
  
  const isLinkActive =
    (prettyLink && trackerLinkActive(operator, tracker)) || directPrettyLink
  const hrefLink = prettyLink || directPrettyLink || '#'

  return isLinkActive ? (
    <a
      href={hrefLink}
      title={`${operator?.name || ''} ${titleSuffix || ''}`.trimEnd() || ''}
      className={className}
      target="_blank"
      rel={rel}
      aria-label={`${operator?.name} ${titleSuffix || 'Link'}`}
      onClick={onCTAClick}
    >
      {children}
    </a>
  ) : (
    <div
      title={`${operator?.name || ''} ${titleSuffix || ''}`.trimEnd() || ''}
      className={className}
      aria-label={`${operator?.name} ${titleSuffix || 'Link'}`}
    >
      {children}
    </div>
  )
}

PrettyLink.propTypes = {
  operator: PropTypes.shape({
    name: PropTypes.string
  }),
  directPrettyLink: PropTypes.string,
  pageTemplate: PropTypes.string,
  moduleName: PropTypes.string,
  titleSuffix: PropTypes.string,
  tracker: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.any
  ]),
  clickedElement: PropTypes.string,
  rel: PropTypes.string,
  modulePosition: PropTypes.number,
  itemPosition: PropTypes.number
}

export default PrettyLink
